import { isAbsoluteUrl } from 'widget/player-widget/utils/url';


const IMAGE_SOURCE_NAME = null;
const JPEG_PARAMS = {
  q: 85,
  usm: '0.66_1.00_0.01',
};


function isJPEG(extension) {
  return /^jpe?g$/i.test(extension);
}


export default function (url, width = 0, height = width, params = {}) {
  if (!url) {
    return '';
  }

  width = Math.round(width);
  height = Math.round(height);

  if (/vimeocdn/.test(url)) {
    return url.replace(/(_\d+(x\d+)?)?\.jpg/, `_${width}x${height}.jpg`);
  }

  if (isAbsoluteUrl(url)) {
    return url;
  }

  if (!width || !height) {
    return url.replace(/\.[^.]+$/, '');
  }

  const fullFilename = url.split('/').pop();
  const imagePath = url.replace(fullFilename, '');

  const filenameSplitted = fullFilename.split('.');
  const filename = filenameSplitted.slice(0, -1).join('.');
  const ext = filenameSplitted[filenameSplitted.length - 1];
  const imageUrlEnd = IMAGE_SOURCE_NAME ? `${filename}_${IMAGE_SOURCE_NAME}.${ext}` : `${filename}.${ext}`;

  params = {
    ...params,
    w: width,
    h: height,
  };

  if (isJPEG(ext)) {
    params = { ...params, ...JPEG_PARAMS };
  }

  const imageParamsPath = _.map(params, (value, key) => `${key}_${value}`).join(',');

  return `${imagePath}v1/fill/${imageParamsPath}/${imageUrlEnd}`;
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/resize-image.js